export type TechSupportUserId = string | number;

export const parseTechSupportUsers = (value: unknown): TechSupportUserId[] => {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value !== 'string') {
    return [];
  }

  try {
    const parsed = JSON.parse(value);

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const isTechSupportUser = (
  profileId: unknown,
  techSupportUsers: TechSupportUserId[],
  isTechSupportEnabled: unknown,
) => isTechSupportEnabled === '1'
  && profileId !== null
  && profileId !== undefined
  && techSupportUsers.some((userId) => String(userId) === String(profileId));
